import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { Sharing, SharingInput } from '../models/sharings';

/**
 * <p>
 * API endpoints that cover all sharing related CRUD calls
 */

export const sharingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    authorizeSharing: builder.mutation<void, string>({
      query: (period: string) => ({
        url: encodeURI(`/indirect/sharing/authorize?period=${period}`),
        method: 'POST',
      }),
      invalidatesTags: ['Sharing', 'Periods'],
    }),
    searchSharingBy: builder.query<PaginationResponse<Sharing>, SharingInput>({
      query: (input: SharingInput) => ({
        url: encodeURI(
          `/indirect/sharing/searchBy?period=${input.period}&destiniProjectSearchTerm=${input.destiniProjectSearchTerm}&originProjectSearchTerm=${input.originProjectSearchTerm}&personSearchTerm=${input.personSearchTerm}&page=${input.page}&size=${input.size}`,
        ),
      }),
      providesTags: ['Sharing'],
    }),
  }),
});

export const { useAuthorizeSharingMutation, useSearchSharingByQuery } = sharingApi;
